var map = {
	"./bonus_symbol_0.png": "df33",
	"./bonus_symbol_1.png": "80cf",
	"./bonus_symbol_2.png": "e519",
	"./bonus_symbol_3.png": "e53a",
	"./bonus_symbol_4.png": "096b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87a2";